import { Component, Input } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ExerciseControllerService } from "../../../core/api/controllers/exercise-controller.service";
import {map} from "rxjs/operators";

@Component({
  selector: "app-select-exercise-category",
  templateUrl: "./select-exercise-category.component.html",
  styleUrls: ["./select-exercise-category.component.scss"],
})
export class SelectExerciseCategoryComponent {
  @Input() _control: FormControl;
  readonly minNameLength = 3;
  readonly maxNameLength = 50;
  readonly reservedCategoryNames = [
    "Favorites",
    "Recent Exercises",
    "Agility Rating",
  ];

  constructor(private exerciseController: ExerciseControllerService) {}

  getCategories(): any {
    return (locationId: string) =>
      this.exerciseController.getCategories(locationId).pipe(
        map(categories =>
          categories.filter(
            category =>
              !this.reservedCategoryNames.some(
                reserved =>
                  reserved.toLowerCase() === category.name?.trim().toLowerCase(),
              ),
          ),
        ),
      );
  }

  saveCategory(): any {
    return this.exerciseController.saveCategory.bind(this.exerciseController);
  }

  updateCategory(): any {
    return this.exerciseController.updateCategory.bind(this.exerciseController);
  }

  deleteCategory(): any {
    return this.exerciseController.deleteCategory.bind(this.exerciseController);
  }
}
